<template>
  <div class="axa-box-general first">
    <div class="box-heading">
      <h2 class="heading">Tanzim / Ürün Bilgileri</h2>
    </div>
    <div class="box-content">
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="endDates"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="endDates"
            label="Tanzim Tarih Aralığı"
            prepend-inner-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            dense
            :rules="[val => val.length > 0 || 'Zorunlu alan!']"
          ></v-text-field>
        </template>
        <v-date-picker v-model="endDates" range no-title scrollable >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false"> İptal </v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(endDates)"> Seç </v-btn>
        </v-date-picker>
      </v-menu>
      <v-autocomplete
        v-model="tarifeKodu"
        :items="tarifeler"
        label="Ürün Kodu"
        item-text="kod"
        item-value="kod"
        dense
        :rules="[val => !!val || 'Zorunlu alan!']"
      >
        <template #item="{ item }">
          {{ item.kod + ' - ' + item.ad }}
        </template>
      </v-autocomplete>
      <v-card-actions class="w-100 text-align-right">
        <v-spacer></v-spacer>
        <slot name="btn" :tarifeKodu="tarifeKodu" :dates="endDates"></slot>
      </v-card-actions>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menu: null,
      endDates: [],
      tarifeKodu: '',
      tarifeler: [
        { kod: 'KNT', ad: 'KONUT SİGORTASI' },
        { kod: 'İŞY', ad: 'İŞYERİ SİGORTASI' },
        //{ kod: 'İŞK', ad: 'İŞYERİ SİGORTASI' },
        //{ kod: 'MKP', ad: 'KONUT SİGORTASI' },
        //{ kod: 'SKL', ad: 'KONUT SİGORTASI' }
      ],
    };
  },
};
</script>
<style lang=""></style>
